export default __webpack_public_path__ + "static/media/clean-air.29fe6f63.svg";